import { Leaf, HeartPulse, Sparkles, MapPin, Utensils, ShieldCheck } from "lucide-react";
import { brand, gallery } from "../mock";

export default function AboutPage() {
  return (
    <main>
      <section className="bg-gradient-to-b from-green-50 to-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20 grid gap-10 lg:grid-cols-2 items-center">
          <div>
            <p className="text-sm font-bold tracking-widest text-green-700">ABOUT US</p>
            <h1 className="mt-2 text-4xl md:text-5xl font-extrabold text-neutral-900">
              Home-style nutrition, made for busy Aucklanders
            </h1>
            <p className="mt-4 text-neutral-600 leading-relaxed">
              {brand.name} was born from a simple idea: eating well shouldn&apos;t be a chore. Our kitchen in Auckland prepares fresh, portion-controlled Indian &amp; fusion tiffin meals with measured protein, controlled oil and zero preservatives — so you can hit your health goals without lifting a spatula.
            </p>
            <div className="mt-6 flex flex-wrap gap-3 text-sm">
              <span className="inline-flex items-center gap-2 rounded-full bg-white border border-neutral-200 px-3 py-1.5"><Utensils size={14} className="text-green-700" /> Cooked fresh daily</span>
              <span className="inline-flex items-center gap-2 rounded-full bg-white border border-neutral-200 px-3 py-1.5"><ShieldCheck size={14} className="text-green-700" /> No preservatives</span>
              <span className="inline-flex items-center gap-2 rounded-full bg-white border border-neutral-200 px-3 py-1.5"><MapPin size={14} className="text-green-700" /> Auckland-wide delivery</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {gallery.slice(0, 4).map((src, i) => (
              <img key={i} src={src} alt={`Meal ${i}`} className={`rounded-2xl object-cover w-full h-40 md:h-56 ${i % 2 ? "translate-y-6" : ""}`} />
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-6 md:grid-cols-3">
          {[
            { icon: HeartPulse, title: "Health-First", desc: "Portioned protein, controlled oil, and balanced macros in every box." },
            { icon: Sparkles, title: "Flavour-Forward", desc: "Home-style recipes with modern twists — no compromise on taste." },
            { icon: Leaf, title: "Fresh Ingredients", desc: "Sourced from trusted NZ suppliers. Cooked the morning of delivery." },
          ].map((f) => (
            <div key={f.title} className="rounded-2xl border border-neutral-200 p-7 bg-white hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 rounded-xl bg-green-600 text-white flex items-center justify-center">
                <f.icon size={22} />
              </div>
              <h3 className="mt-4 text-lg font-bold text-neutral-900">{f.title}</h3>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-neutral-50 border-y border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-8 md:grid-cols-3">
          <div>
            <p className="text-4xl font-extrabold text-green-700">2,500+</p>
            <p className="mt-1 text-sm text-neutral-600">Meals delivered every week</p>
          </div>
          <div>
            <p className="text-4xl font-extrabold text-green-700">14</p>
            <p className="mt-1 text-sm text-neutral-600">Auckland suburbs served</p>
          </div>
          <div>
            <p className="text-4xl font-extrabold text-green-700">100%</p>
            <p className="mt-1 text-sm text-neutral-600">Fresh, preservative-free cooking</p>
          </div>
        </div>
      </section>
    </main>
  );
}
